export default __webpack_public_path__ + "static/media/CapaWheel.9777d6f9.png";